import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore/lite';
import { getAnalytics } from 'firebase/analytics';

let config = {
    apiKey: import.meta.env.VITE_API_KEY,
    authDomain: import.meta.env.VITE_AUTH_DOMAIN,
    databaseURL: import.meta.env.VITE_DATABASE_URL,
    projectId: import.meta.env.VITE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_STORAGE_BUCKET,
    appId: import.meta.env.VITE_APP_ID,
    measurementId: import.meta.env.VITE_MEASUREMENT_ID,
    messagingSenderId: import.meta.env.VITE_MESSAGING_SENDER_ID
};

export const firebase = initializeApp(config);
export const storage = getStorage(firebase);
export const db = getFirestore(firebase);
export const auth = getAuth(firebase);
export const analytics = getAnalytics(firebase);

if (import.meta.env.MODE === "localhost") {
    connectFirestoreEmulator(db, '127.0.0.1', 8080);
    connectStorageEmulator(storage, '127.0.0.1', 9199);
}